import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Text from './Text/Text';
import './NavigationBar.css';

const NavigationBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Check if a route is active
  const isActive = (path: string) => {
    return location.pathname.includes(path);
  };
  
  return (
    <div className="navigation-bar">
      <div
        className={`nav-item ${isActive('/home') ? 'active' : ''}`}
        onClick={() => navigate('/home')}
      >
        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" fill="none">
          <path
            d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <Text className="text-caption">Home</Text>
      </div>
      
      <div
        className={`nav-item ${isActive('/notifications') ? 'active' : ''}`}
        onClick={() => navigate('/notifications')}
      >
        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" fill="none">
          <path
            d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.73 21a2 2 0 01-3.46 0"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <Text className="text-caption">Notifications</Text>
      </div>
      
      <div
        className={`nav-item ${isActive('/transactions') ? 'active' : ''}`}
        onClick={() => navigate('/transactions')}
      >
        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" fill="none">
          <rect
            x="3"
            y="3"
            width="18"
            height="18"
            rx="2"
            ry="2"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="3"
            y1="9"
            x2="21"
            y2="9"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="9"
            y1="21"
            x2="9"
            y2="9"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <Text className="text-caption">Transactions</Text>
      </div>
      
      <div
        className={`nav-item ${isActive('/profile') ? 'active' : ''}`}
        onClick={() => navigate('/profile')}
      >
        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" fill="none">
          <path
            d="M12 4a4 4 0 100 8 4 4 0 000-8z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <Text className="text-caption">Profile</Text>
      </div>
    </div>
  );
};

export default NavigationBar;